'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @date 2015/12/27
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Integer = require('./Integer');

var _Integer2 = _interopRequireDefault(_Integer);

var _Arrays = require('../util/Arrays');

var _Arrays2 = _interopRequireDefault(_Arrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StringBuilder = (function () {
    function StringBuilder() {
        var capacity = arguments.length <= 0 || arguments[0] === undefined ? 16 : arguments[0];

        _classCallCheck(this, StringBuilder);

        this.value = new Array(capacity);
        this.count = 0;
    }

    _createClass(StringBuilder, [{
        key: 'append',
        value: function append(v) {
            if (v == null) {
                return this._appendNull();
            }
            if (typeof v !== 'string') {
                v = String(v);
            }
            var len = v.length;
            this._ensureCapacityInternal(this.count + len);
            this.value.push(v);
            this.count += len;
            return this;
        }
    }, {
        key: 'length',
        value: function length() {
            return this.count;
        }
    }, {
        key: 'capacity',
        value: function capacity() {
            return this.value.length;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.value.join('');
        }
    }, {
        key: '_ensureCapacityInternal',
        value: function _ensureCapacityInternal(minimumCapacity) {
            if (minimumCapacity - this.value.length > 0) {
                this._expandCapacity(minimumCapacity);
            }
        }
    }, {
        key: '_expandCapacity',
        value: function _expandCapacity(minimumCapacity) {
            var newCapacity = value.length * 2 + 2;
            if (newCapacity - minimumCapacity < 0) {
                newCapacity = minimumCapacity;
            }
            if (newCapacity < 0) {
                if (minimumCapacity < 0) // overflow
                    throw Error('OutOfMemoryError');
                newCapacity = _Integer2.default.MAX_VALUE;
            }
            this.value = _Arrays2.default.copyOf(this.value, newCapacity);
        }
    }, {
        key: '_appendNull',
        value: function _appendNull() {
            var c = this.count;
            this._ensureCapacityInternal(c + 4);
            var value = this.value;
            value[c++] = 'n';
            value[c++] = 'u';
            value[c++] = 'l';
            value[c++] = 'l';
            this.count = c;
            return this;
        }
    }]);

    return StringBuilder;
})();

exports.default = StringBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdk/lang/StringBuilder.js
// module id = 35
// module chunks = 0